import React from 'react';
import { WeezHeader, Button, Icon, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import TicketOfficeOperatorList from './ticketOfficeOperatorList';
import ConfirmModal from '../../../../components/confirmModal';
import { fetcher } from '@weezevent/weezjs-core';
import { useHistory } from 'react-router-dom';
import { ticketOfficeContext } from '../../../../components/routing/ticketOfficeRouter';

export default function TicketOfficeOperator({ organization, ticket_office }) {
    const { t } = useTranslation();
    const [deleteObject, setDeleteObject] = React.useState(false);
    const syncTicketOffice = React.useContext(ticketOfficeContext);
    const toast = React.useContext(ToastContext);
    let history = useHistory();

    const onSubmitDelete = React.useCallback(
        id => {
            fetcher
                .delete(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/users/${deleteObject.id}`, {
                    method: 'DELETE'
                })
                .then(() => {
                    toast.success(t('ticket.ticket_offices.operators.delete.sucess', { name: deleteObject.name }));
                    syncTicketOffice({
                        allow_cache: false,
                        cache: false
                    });
                })
                .catch(err => {
                    toast.error(t(`ticket.mailing.toast_error`));
                })
                .finally(() => {
                    syncTicketOffice({
                        allow_cache: false,
                        cache: false
                    });
                    setDeleteObject(false);
                });
        },
        [deleteObject]
    );
    const addOperator = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/users/new`);
    }, [history, organization, ticket_office]);

    return (
        <>
            <WeezHeader
                title={t('ticket.ticket_offices.operators.pageTitle')}
                rightComponent={<Button primary onClick={addOperator} icon={<Icon name={'plus'} margin={false} />} label={t('ticket.ticket_offices.operators.label')} />}
            >
                {t('ticket.ticket_offices.operators.header_description')}
            </WeezHeader>

            {deleteObject && (
                <ConfirmModal
                    labelTitle={t('ticket.ticket_offices.operators.delete.title')}
                    labelBody={t('ticket.ticket_offices.operators.delete.body', { name: deleteObject.name })}
                    objectToSave={deleteObject}
                    onClose={() => setDeleteObject(false)}
                    onAccept={onSubmitDelete}
                />
            )}
            <TicketOfficeOperatorList organization={organization} ticket_office={ticket_office} setDeleteObject={setDeleteObject} syncTicketOffice={syncTicketOffice} />
        </>
    );
}
